import {
  subscribeToMessages,
  unsubscribeToMessages,
} from './api/simulateSpecialsMessages';
import {
  getSimulateSpecialsElements,
  clearSimulateSpecialsElements,
} from './ui/simulateSpecialsElements';
import { getOTP } from './api/prepareOtp';
import { getSDKConfig } from '../../shares/lib/getSDKConfig';
import { renderSimulateSpecialsIframe } from './ui/renderIframe';
import eventEmitters from '../../shares/lib/eventEmitters';
import eventType from '../../shares/enums/eventType';
import { validate } from 'superstruct';
import { SimulateSpecialsConfigSchema } from '../../shares/model/simulateSpecials';
import { isTenantFeatureEnabled } from '../../shares/helpers/tenantFeatureHelper';
import { TenantFeature } from '../../shares/enums/tenantFeatures';

let isSimulateSpecialsLaunched = false;

export async function simulateSpecialsLaunch() {
  const swipeSDKConfig = getSDKConfig();

  if (
    !swipeSDKConfig.enableSimulateSpecials ||
    !swipeSDKConfig.simulateSpecials
  ) {
    return;
  }

  const [configError] = validate(
    swipeSDKConfig.simulateSpecials,
    SimulateSpecialsConfigSchema,
  );
  if (configError) {
    console.error('Invalid simulate specials config:', configError);
    throw new Error(`Invalid simulate specials config: ${configError.message}`);
  }

  const { mains, showLoader, showError, hideLoader } =
    getSimulateSpecialsElements();

  const iframeUrl = new URL(
    swipeSDKConfig.simulateSpecials.iframeSourceUrl ?? '',
  );
  iframeUrl.searchParams.set(
    'tenant_id',
    swipeSDKConfig?.simulateSpecials?.tenantId
      ? swipeSDKConfig.simulateSpecials.tenantId
      : swipeSDKConfig.tenantId,
  );
  iframeUrl.searchParams.set(
    'locale',
    swipeSDKConfig.simulateSpecials.locale ?? 'en',
  );
  iframeUrl.searchParams.set(
    'source',
    swipeSDKConfig.simulateSpecials.source ?? '',
  );

  try {
    showLoader();

    if (isTenantFeatureEnabled([TenantFeature.SIMULATE_SPECIALS_OTP_IN_URL])) {
      const otp = await getOTP();
      iframeUrl.searchParams.set('otp', otp);
    }

    await renderSimulateSpecialsIframe(mains, iframeUrl.toString(), hideLoader);

    await subscribeToMessages();

    eventEmitters(eventType.SIMULATE_SPECIALS_READY, 'SimulateSpecials', {
      eventType: eventType.SIMULATE_SPECIALS_READY,
    });
  } catch (e) {
    showError();
    throw e;
  } finally {
    isSimulateSpecialsLaunched = true;
  }
}

export async function simulateSpecialsRemove() {
  if (isSimulateSpecialsLaunched) {
    await unsubscribeToMessages();
    clearSimulateSpecialsElements();
    isSimulateSpecialsLaunched = false;
    eventEmitters(eventType.SIMULATE_SPECIALS_CLOSED, 'SimulateSpecials');
  }
}
